import { c as _c } from "react/compiler-runtime";
import { SlidersHorizontal } from "lucide-react";
import { PromotionalCardBase } from "../card-base";
import { PromotionalCardProps } from "../types";
export function TryPreferencesCard(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SlidersHorizontal className="w-full h-full" strokeWidth={1.5} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <PromotionalCardBase icon={t1} title="Personalize Your Search" description="Set your preferences once & get AI-matched properties delivered to you" ctaText="Try Preferences" href="/preference-update" className={className} iconColor="text-violet-600" />;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}